export { default } from '@/components/ConstructorAddButton';
